import { makeStyles } from '@material-ui/core';
import type { IssueStateCategory } from '../../api/types';

export const useIssuePickerStyles = makeStyles(theme => ({
  assignee: { marginLeft: theme.spacing(1) },
  searchRow: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  badge: {
    marginLeft: theme.spacing(1),
  },
  empty: {
    padding: theme.spacing(3),
    color: theme.palette.text.secondary,
    textAlign: 'center',
  },
}));

export const STATE_CATEGORY_COLORS: Record<
  IssueStateCategory,
  'default' | 'primary' | 'secondary'
> = {
  open: 'default',
  'in-progress': 'secondary', // Spassu orange in the brand palette
  done: 'primary',
};
